/*
 * Tiefenwerk — Akkordeon
 *
 * Das Markup rendert alle Antworten offen, damit die Seite ohne JavaScript
 * vollständig lesbar bleibt. Erst hier wird zugeklappt und das Umschalten
 * übernommen. Die Höhe läuft über Grid-Zeilen (0fr → 1fr), siehe tw-ui.css.
 */
(function () {
  function init(root) {
    var items = root.querySelectorAll('.acc__item');
    if (!items.length) return;

    Array.prototype.forEach.call(items, function (item, index) {
      var button = item.querySelector('.acc__q');
      if (!button) return;

      // Nur das erste Element bleibt offen
      setOpen(item, button, index === 0);

      button.addEventListener('click', function () {
        var wasOpen = item.getAttribute('data-open') === 'true';
        Array.prototype.forEach.call(items, function (other) {
          setOpen(other, other.querySelector('.acc__q'), false);
        });
        if (!wasOpen) setOpen(item, button, true);
      });
    });
  }

  function setOpen(item, button, open) {
    item.setAttribute('data-open', open ? 'true' : 'false');
    if (button) button.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function boot() {
    document.querySelectorAll('.acc').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Im Theme-Editor wird die Sektion neu eingehängt, dann erneut verdrahten
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.acc').forEach(init);
  });
})();
